var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"form-group"},[_c('label',{staticClass:"fgcaption"},[_vm._v(_vm._s(_vm.caption))]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"fgdescription"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"fgcontainer"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ec76e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primitives/cp1-form-group/FormGroup.vue
// module id = null
// module chunks = 